import React, { useState } from 'react';
import qrFake1 from '../assets/scenarios/bike-qr/qr-fake-1.png';
import qrFake2 from '../assets/scenarios/bike-qr/qr-fake-2.png';
import qrFake3 from '../assets/scenarios/bike-qr/qr-fake-3.png';
import qrFakeOfficial from '../assets/scenarios/bike-qr/qr-fake-official.png';
import qrOfficial from '../assets/scenarios/bike-qr/qr-official.png';

type ScanResultType = 'idle' | 'success' | 'warning' | 'danger';

const BikeQrScenario: React.FC = () => {
  const bikes = [
    { id: 1, isOfficial: false, fakeType: '收款二维码', qr: qrFake1 },
    { id: 2, isOfficial: false, fakeType: '钓鱼网站', qr: qrFake2 },
    { id: 3, isOfficial: false, fakeType: '山寨APP', qr: qrFake3 },
    { id: 4, isOfficial: false, fakeType: '伪造官方二维码', qr: qrFakeOfficial, specialWarning: '二维码无法识别，请更换车辆并重新扫码。' },
    { id: 5, isOfficial: true, fakeType: '', qr: qrOfficial }
  ];

  const tools = [
    { id: 'wechat', label: '微信' },
    { id: 'official', label: '青桔APP' },
    { id: 'browser', label: '手机浏览器' },
    { id: 'other', label: '其他扫码工具' }
  ];

  const [selectedTool, setSelectedTool] = useState<string>('wechat');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [resultType, setResultType] = useState<ScanResultType>('idle');
  const [resultMessage, setResultMessage] = useState('');

  const currentBike = bikes[currentIndex];

  const handleScan = () => {
    if (!selectedTool) {
      setResultType('warning');
      setResultMessage('请先选择扫码方式。');
      return;
    }

    if (selectedTool !== 'official') {
      setResultType('danger');
      setResultMessage('恶意跳转至支付，你的钱被转空了！可惜没如果~');
      return;
    }

    if (!currentBike.isOfficial) {
      setResultType('warning');
      if (currentBike.specialWarning) {
        setResultMessage(currentBike.specialWarning);
      } else {
        setResultMessage('官方APP无法识别该二维码，可能存在风险，建议更换车辆。');
      }
      return;
    }

    setResultType('success');
    setResultMessage('扫码成功，已进入骑行模式。');
  };

  const handleNextBike = () => {
    if (currentIndex < bikes.length - 1) {
      setCurrentIndex(prev => prev + 1);
      setResultType('idle');
      setResultMessage('');
      return;
    }
    setCurrentIndex(0);
    setResultType('idle');
    setResultMessage('');
  };

  const handleRestart = () => {
    setCurrentIndex(0);
    setSelectedTool('wechat');
    setResultType('idle');
    setResultMessage('');
  };

  return (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl p-6">
        <h4 className="text-2xl font-bold text-emerald-800 mb-2">共享单车二维码骗局</h4>
        <p className="text-gray-700">
          你看到青桔共享单车，准备扫码骑走。注意！诈骗分子会在单车上粘贴不良二维码，扫码后可能转账或下载木马程序。请选择正确扫码方式并识别真假二维码。
        </p>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
        <h5 className="text-lg font-semibold text-gray-800 mb-3">选择扫码方式</h5>
        <div className="flex flex-wrap gap-3">
          {tools.map(tool => (
            <button
              key={tool.id}
              onClick={() => setSelectedTool(tool.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition ${
                selectedTool === tool.id
                  ? 'bg-emerald-600 text-white border-emerald-600'
                  : 'bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200'
              }`}
            >
              {tool.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid lg:grid-cols-[2fr,1fr] gap-6">
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <h5 className="text-lg font-semibold text-gray-800">当前车辆二维码</h5>
            <span className="text-sm text-gray-500">第 {currentIndex + 1} / {bikes.length} 辆</span>
          </div>
          <div className="flex items-center gap-6">
            <div className="w-40 h-40 bg-white rounded-lg border border-gray-200 p-3 flex items-center justify-center">
              <img
                src={currentBike.qr}
                alt="二维码"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <p className="text-sm text-gray-700 mb-2">
                提示：观察二维码是否被覆盖、粘贴或有撕裂痕迹。
              </p>
              <span className="inline-block bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                外观需核验
              </span>
            </div>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              onClick={handleScan}
              className="px-6 py-3 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 transition"
            >
              立即扫码
            </button>
            <button
              onClick={handleNextBike}
              className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition"
            >
              下一辆
            </button>
          </div>
        </div>

        <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
          <h5 className="text-lg font-semibold text-gray-800 mb-3">扫码反馈</h5>
          <div
            className={`rounded-lg p-4 text-sm ${
              resultType === 'success'
                ? 'bg-green-50 border border-green-200 text-green-700'
                : resultType === 'warning'
                  ? 'bg-yellow-50 border border-yellow-200 text-yellow-700'
                  : resultType === 'danger'
                    ? 'bg-red-50 border border-red-200 text-red-700'
                    : 'bg-gray-50 border border-gray-200 text-gray-600'
            }`}
          >
            {resultType === 'idle' ? '请选择扫码方式并点击“立即扫码”。' : resultMessage}
          </div>
          {resultType === 'danger' && (
            <button
              onClick={handleRestart}
              className="mt-4 w-full px-4 py-2 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition"
            >
              如果那天。。。
            </button>
          )}

          {(resultType === 'warning' || resultType === 'danger') && (
            <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4">
              <h6 className="font-semibold text-red-700 mb-2">骗局原理提示</h6>
              <ul className="text-sm text-gray-700 space-y-1">
                <li>收款二维码：贴上转账码，诱导直接付款。</li>
                <li>钓鱼网站：伪造官网页面骗取身份或银行卡信息。</li>
                <li>山寨APP：诱导下载假APP，植入木马程序。</li>
              </ul>
            </div>
          )}

          {resultType === 'success' && (
            <div className="mt-4 bg-emerald-50 border border-emerald-200 rounded-lg p-4">
              <p className="text-sm text-emerald-700">
                做得好！通过官方APP扫码才是最安全的方式。
              </p>
            </div>
          )}
        </div>
      </div>

      {resultType === 'success' && (
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-6">
          <h5 className="text-lg font-semibold text-blue-800 mb-2">安全小贴士</h5>
          <ul className="text-sm text-gray-700 space-y-1">
            <li>扫码前观察二维码是否被覆盖或粘贴。</li>
            <li>只通过官方APP扫码骑行，不使用第三方工具。</li>
            <li>遇到跳转付款、下载APP等提示应立即停止。</li>
          </ul>
          <div className="text-sm text-gray-700 mt-4 space-y-3">
            <p>
              最近，全国连发多起共享单车被贴虚假二维码的诈骗事件，用户手机扫描此类二维码后，或被要求直接转账，或被要求下载可疑软件，致使资金账户面临被盗刷的风险。为此，反诈骗专家提醒，在使用共享单车时，须警惕不法分子设置的扫码陷阱。
            </p>
            <p>目前共享单车的二维码骗局主要包括以下三种形式。</p>
            <p>
              一是单车贴上收款二维码。骗子在正规二维码旁边贴上微信或支付宝转账二维码，甚至破坏单车原有二维码，直接粘贴骗子收款的二维码。用户一旦没有辨别清楚扫到假的二维码，就会跳转至转账界面。同时，骗子还常常会将自己的收款头像设置成共享单车品牌logo，极具迷惑性。
            </p>
            <p>
              二是钓鱼网站骗信息。直接转账容易被警惕性高的用户察觉出猫腻，有些骗子制作出高仿共享单车官方网站的钓鱼页面，以完善身份认证等名义诱骗用户主动填写个人身份信息和银行卡资料，从而进一步实施精准诈骗甚至盗刷网银。
            </p>
            <p>
              三是山寨APP藏木马。租用共享单车必须使用租车APP，骗子就设计了假租车APP二维码粘贴在单车上，提示用户“更新”。用户扫码后看似安装了租车软件，其实手机却被植入了木马。
            </p>
            <p>
              为提高安全意识，专家给骑行友们支招，要通过正规应用商店下载共享单车APP，避免遭遇山寨APP而导致手机被植入木马病毒;扫码前一定要仔细辨别二维码是否存在被撬、被更换、被涂改、被覆盖、粘贴等痕迹。如果二维码是粘上去的，务必提高警惕;正规二维码扫描后一般会进入使用模式，不会跳转至付款页面。目前大部分共享单车只能通过官方APP支付，扫码用车时，切记通过官方APP扫描，不要使用其他扫码工具。
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BikeQrScenario;
